import { toRGB } from "./helper";
import tailwindColors from "tailwindcss/colors";
import { flatten } from "flat";
const colors = {
    ...tailwindColors,
    theme: {
        1: "rgb(var(--color-theme-1) / <alpha-value>)",
        2: "rgb(var(--color-theme-2) / <alpha-value>)",
    },
    primary: "rgb(var(--color-primary) / <alpha-value>)",
    secondary: "rgb(var(--color-secondary) / <alpha-value>)",
    success: "rgb(var(--color-success) / <alpha-value>)",
    info: "rgb(var(--color-info) / <alpha-value>)",
    warning: "rgb(var(--color-warning) / <alpha-value>)",
    pending: "rgb(var(--color-pending) / <alpha-value>)",
    danger: "rgb(var(--color-danger) / <alpha-value>)",
    light: "rgb(var(--color-light) / <alpha-value>)",
    dark: "rgb(var(--color-dark) / <alpha-value>)",
    darkmode: {
        50: "rgb(var(--color-darkmode-50) / <alpha-value>)",
        100: "rgb(var(--color-darkmode-100) / <alpha-value>)",
        200: "rgb(var(--color-darkmode-200) / <alpha-value>)",
        300: "rgb(var(--color-darkmode-300) / <alpha-value>)",
        400: "rgb(var(--color-darkmode-400) / <alpha-value>)",
        500: "rgb(var(--color-darkmode-500) / <alpha-value>)",
        600: "rgb(var(--color-darkmode-600) / <alpha-value>)",
        700: "rgb(var(--color-darkmode-700) / <alpha-value>)",
        800: "rgb(var(--color-darkmode-800) / <alpha-value>)",
        900: "rgb(var(--color-darkmode-900) / <alpha-value>)",
    },
};
/** Get a value from Tailwind colors by flatten index, if not available the value will be taken from the CSS variable with (--color-) prefix. */
const getColor = (colorKey, opacity = 1) => {
    const flattenColors = flatten(colors);
    if (flattenColors[colorKey].search("var") === -1) {
        return `rgb(${toRGB(flattenColors[colorKey])} / ${opacity})`;
    }
    else {
        const cssVariableName = `--color-${flattenColors[colorKey].split("--color-")[1].split(")")[0]}`;
        return `rgb(${getComputedStyle(document.body).getPropertyValue(cssVariableName)} / ${opacity})`;
    }
};
export { getColor };